module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "21",
      "height": "18",
      "viewBox": "0 0 21 18",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10.9311 6.99975V8.99975M10.9311 12.9998H10.9411M4.00308 16.9998H17.8591C19.3991 16.9998 20.3611 15.3328 19.5911 13.9998L12.6631 1.99975C11.8931 0.66675 9.96908 0.66675 9.19908 1.99975L2.27108 13.9998C1.50108 15.3328 2.46308 16.9998 4.00308 16.9998Z",
      "stroke": "#3F3F46",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6312fe7e","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/alert.vue
// module id = 8d61c3bccb30ec0c9c81
// module chunks = 89